export default {
    data() {
        return {
            isLoading: false
        }
    },

    methods: {
        setIsLoadingFlagTo(isLoading) { this.isLoading=isLoading },
    },
}